import RefundTransactions from "./refund-transactions.view";

export default RefundTransactions;
